// extracted by mini-css-extract-plugin
export default {"box_06":"style_box_06_sikVe","clearfix":"style_clearfix_2SBqB"};